import { ReportRow } from "../types";
import ReportDataTable from "./ReportDataTable";

interface SpareReturnReportProps {
  rows: ReportRow[];
}

const SpareReturnReport = ({ rows }: SpareReturnReportProps) => (
  <ReportDataTable rows={rows} emptyMessage="No spare return report data found." />
);

export default SpareReturnReport;
